import type React from 'react';

import Popover, { type PopoverProps } from '@mui/material/Popover';

import { useStyles } from 'components/popovers/styles';

const TMXPopover: React.FC<React.PropsWithChildren<PopoverProps>> = ({ children, ...props }) => {
  const { classes } = useStyles();
  return (
    <Popover
      {...props}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
      classes={{ paper: classes.popoverPaper }}
      className={classes.tmxPopover}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
    >
      {children}
    </Popover>
  );
};

export default TMXPopover;
